import React from "react";
import { Outlet } from "react-router-dom";
const Loading = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Loading;
